<form [formGroup]="scheduleForm">
  <div class="p-20" style="font-family: Poppins;">
    <div class="d-flex justify-content-between align-items-center pb-3">
      <h2 mat-dialog-title class="m-0">{{ 'Schedule' }}</h2>

      <div class="p-2" style="margin: 0 0 -5px 0px !important;">
        <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
      </div>
    </div>

    <div class="schedule-fields">
      <mat-form-field appearance="fill">
        <mat-label>From Date & Time</mat-label>

        <!-- Combined read-only display -->
        <input matInput [value]="fromDateTimeDisplay" readonly (click)="fromDatePicker.open()">

        <!-- Hidden bound input to preserve formControl for fromDate -->
        <input matInput [matDatepicker]="fromDatePicker" [matDatepickerFilter]="dateFilterFrom" (dateChange)="selectFromDate($event)"
          formControlName="fromDate" style="display: none;" />

        <!-- Calendar Icon -->
        <button mat-icon-button matSuffix (click)="fromDatePicker.open()" type="button">
          <mat-icon>calendar_today</mat-icon>
        </button>

        <!-- Time Selector Icon -->
        <button mat-icon-button matSuffix  #fromTimeMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="fromTimeMenu" 
          (click)="generateFromTimeSlots()" type="button">
          <mat-icon>access_time</mat-icon>
        </button>
        <mat-hint align="start">
          <button mat-button color="primary" class="btn" (click)="setCurrentTime()">Set Current</button>
        </mat-hint>

        <!-- Datepicker -->
        <mat-datepicker #fromDatePicker (dateChange)="selectFromDate($event)"
          [matDatepickerFilter]="dateFilterFrom"></mat-datepicker>
      </mat-form-field>

      <!-- Time options menu -->
      <mat-menu #fromTimeMenu="matMenu">
        <button mat-menu-item *ngFor="let time of fromTimeSlots" [disabled]="time.disabled"
          (click)="onTimeOptionSelected(time)">
          {{ time.label }}
        </button>
      </mat-menu>

      <!-- TO DATE & TIME FIELD -->
      <mat-form-field appearance="fill">
        <mat-label>To Date & Time</mat-label>

        <!-- Combined read-only display -->
        <input matInput [value]="toDateTimeDisplay" readonly (click)="toDatePicker.open()">

        <!-- Hidden input to bind formControl for toDate -->
        <input matInput [matDatepicker]="toDatePicker" [matDatepickerFilter]="dateFilterTo" formControlName="toDate" (dateChange)="selectToDate($event)"
          style="display: none;" />

        <!-- Calendar icon -->
        <button mat-icon-button matSuffix (click)="toDatePicker.open()" type="button">
          <mat-icon>calendar_today</mat-icon>
        </button>

        <!-- Time selector icon -->
        <button mat-icon-button matSuffix #toTimeMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="toTimeMenu" (click)="generateToTimeSlots()"
          type="button">
          <mat-icon>access_time</mat-icon>
        </button>
        <mat-hint align="start">
          <button mat-button color="primary" class="btn" (click)="setCurrentTime()">Set Current</button>
        </mat-hint>

        <!-- Datepicker -->
        <mat-datepicker #toDatePicker (dateChange)="selectToDate($event)" [dateFilter]="dateFilterTo"></mat-datepicker>
      </mat-form-field>

      <!-- TO TIME MENU -->
      <mat-menu #toTimeMenu="matMenu">
        <button mat-menu-item *ngFor="let time of toTimeSlots" [disabled]="time.disabled"
          (click)="onToTimeSelected(time)">
          {{ time.label }}
        </button>
      </mat-menu>

    </div>

    <div class="schedule-buttons">
      <button mat-button color="primary" class="btn" (click)="setCurrentTime()">Set Current</button>
      <button mat-raised-button color="accent" (click)="applySchedule()">Apply</button>
    </div>
  </div>
</form>